import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor"

export const getIngresosQC = async (date) => {
   return PrivateInterceptor('Produccion/QC/getIngresosQC', 'POST', date);
}

export const getInventarioQC = async () => {
    return PrivateInterceptor('Produccion/QC/getInventarioQC', 'GET')
}

export const getSalidasCocina = async (date) => {
    return PrivateInterceptor('Produccion/QC/getSalidasCocina', 'POST', date)
}


// PLANTA DE TRATAMIENTO
export const getInventarioPlantaTratamiento = async () => {
    return PrivateInterceptor('Produccion/QC/getInventarioPlantaTramiento', 'GET')
}

export const getIngresosQCPlantaTratamiento = async (date) => {
    return PrivateInterceptor('Produccion/QC/getIngresosPlantaTratamiento', 'POST', date);
}

export const getSalidasPlantaTratamiento = async (date) => {
    return PrivateInterceptor('Produccion/QC/getSalidasPlantaTratamiento', 'POST', date)
}

export const getControlMSDS = async (date) => {
    return PrivateInterceptor('Produccion/QC/ControlMSDS', 'GET', date)
}


export const getListFile = async (IdProductoSuministro, area) => {
    return PrivateInterceptor(`Produccion/QC/getListFiles/${IdProductoSuministro}/${area}`, 'GET')
}

export const getFile = async (IdFile) => {
    return PrivateInterceptor(`Produccion/QC/getFile/${IdFile}`, 'GET')
}